
import { Component, Vue, Prop, Watch, Ref } from "vue-property-decorator";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";

@Component({
  name: "p-form-input-text-search",
  components: { PIcon },
})
export class PFormInputTextSearch extends Vue {
  @Prop({ required: true }) value!: string;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = typeof this.value === "string" ? this.value : "";
  }

  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: true }) show!: boolean;

  @Ref("inputRef") readonly inputRef!: HTMLInputElement | any;

  valueLocal: string = "";
  showInput = false;

  mounted() {
    this.showInput = this.show;
  }

  get classComp() {
    return this.valueLocal !== ""
      ? "search_PFormInputTextSearch active_PFormInputTextSearch"
      : "search_PFormInputTextSearch";
  }

  onInput(): void {
    const cleanValue = this.valueLocal.trim();
    this.$emit("input", cleanValue);
    this.$emit("change", cleanValue);
  }

  onKeyUp(e: KeyboardEvent): void {
    if (e.key === "Enter") {
      this.doSearch();
    } else {
      const target = e.target as HTMLInputElement | null;
      const raw = target ? target.value.trim() : this.valueLocal.trim();
      this.$emit("change", raw);
    }
  }

  doSearch(): void {
    const clean = (this.valueLocal ?? "").trim();
    this.$emit("enter-pressed", clean);
    this.$emit("search", clean);
  }

  click(): void {
    this.showInput = true;
    this.$nextTick(() => {
      if (this.inputRef && typeof this.inputRef.focus === "function") {
        this.inputRef.focus();
      }
    });
    this.$emit("click");
  }

  mouseleave(): void {
    if (this.valueLocal === "" && !this.show) {
      this.showInput = false;
    }
  }
}
export default PFormInputTextSearch;
